import {
  Box,
  Button,
  Checkbox,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  TablePagination,
  Backdrop,
  CircularProgress,
  MenuItem,
  IconButton
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { Barra } from "../components/Barra";
import { generarGuion, obtenerGuion } from "../services/guiones.service";
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from "react-router-dom";
import { validarAccesoGuiones } from '../services/accesoGuiones';


export default function Guiones() {
  const { user } = React.useContext(AuthContext);
  const [modulos, setModulos] = useState([]);
  const [seleccionadas, setSeleccionadas] = useState([]);

  const [filtroModulo, setFiltroModulo] = useState("");
  const [filtroFechaInicio, setFiltroFechaInicio] = useState("");
  const [filtroFechaFin, setFiltroFechaFin] = useState("");

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const totalPaginas = Math.ceil(total / pageSize);

  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const [ordenColumna, setOrdenColumna] = useState(null);
  const [ordenAscendente, setOrdenAscendente] = useState(true);

  const colores = {
    titulo: "#182844",
    primario: "#102A8A",
    alerta: "#AA0000"
  };

  const handleOrdenar = (columna) => {
  if (ordenColumna === columna) {
    setOrdenAscendente(!ordenAscendente);
  } else {
    setOrdenColumna(columna);
    setOrdenAscendente(true);
  }
};

const modulosOrdenados = [...modulos].sort((a, b) => {
  if (!ordenColumna) return 0;

  const valorA = a[ordenColumna];
  const valorB = b[ordenColumna];

  if (valorA == null) return 1;
  if (valorB == null) return -1;

  if (typeof valorA === "string") {
    return ordenAscendente
      ? valorA.localeCompare(valorB)
      : valorB.localeCompare(valorA);
  }

  return ordenAscendente ? valorA - valorB : valorB - valorA;
});


  const fetchData = async () => {
    setCargando(true);
    try {
      const url = `${process.env.REACT_APP_URL_APP}asignaturas/paginar?codigo=${filtroModulo}&fechaInicio=${filtroFechaInicio}&fechaFin=${filtroFechaFin}&page=${page + 1}&pageSize=${pageSize}`;
      const config = {
        method: "get",
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.authorization.token,
        },
      };
      const response = await axios(config);
      setModulos(response.data.asignaturas || []);
      setTotal(response.data.total || 0);
    } catch (error) {
      console.error("Error al cargar los datos:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    
    const validar = async () => {
      await validarAccesoGuiones({
      rut: user.rut,
      token: user.authorization.token,
      navigate
      });
    };
    
    if (user?.rut) {
      validar();
    }


    fetchData();
  }, [page, pageSize, user, navigate]);

  const handleBuscar = () => {
    setPage(0);
    fetchData();
  };

  const limpiarFiltros = () => {
    setFiltroModulo("");
    setFiltroFechaInicio("");
    setFiltroFechaFin("");
    setPage(0);
  };

  const toggleSeleccion = (moduloCodigo, unidadId) => {
    const key = `${moduloCodigo}-${unidadId}`;
    setSeleccionadas((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  const generarGuionUnidad = async (unidadId, moduloCodigo) => {
    setCargando(true);
    try {
      await generarGuion(unidadId, user.authorization.token, user.rut);
      const output = await obtenerGuion(unidadId, user.authorization.token);
      const nuevoGuion = [{ id: Date.now(), output }];
      setModulos((prevModulos) =>
        prevModulos.map((modulo) =>
          modulo.codigo === moduloCodigo
            ? {
                ...modulo,
                unidades: modulo.unidades.map((unidad) =>
                  unidad.id === unidadId
                    ? { ...unidad, guion: nuevoGuion }
                    : unidad
                ),
              }
            : modulo
        )
      );
    } catch (error) {
      console.error("Error generando guion:", error);
      alert("Ocurrió un error al generar el guion.");
    } finally {
      setCargando(false);
    }
  };

  const handleGenerarMasivo = async () => {
    if (seleccionadas.length === 0) return;
    if (seleccionadas.length > 10) {
      alert("Solo puedes generar un máximo de 10 guiones a la vez.");
      return;
    }
    setCargando(true);
    const errores = [];
    const nuevasUnidades = {};
    for (const key of seleccionadas) {
      const [moduloCodigo, unidadId] = key.split("-");
      try {
        await generarGuion(unidadId, user.authorization.token, user.rut);
        const output = await obtenerGuion(unidadId, user.authorization.token);
        nuevasUnidades[unidadId] = {
          id: Date.now(),
          output,
          moduloCodigo,
        };
      } catch (err) {
        errores.push(unidadId);
      }
    }
    setModulos((prevModulos) =>
      prevModulos.map((modulo) => {
        const nuevasUnidadesModulo = modulo.unidades.map((unidad) => {
          if (nuevasUnidades[unidad.id]) {
            return {
              ...unidad,
              guion: [nuevasUnidades[unidad.id]],
            };
          }
          return unidad;
        });
        return {
          ...modulo,
          unidades: nuevasUnidadesModulo,
        };
      })
    );
    setCargando(false);
    if (errores.length === 0) {
      alert("Todos los guiones fueron generados correctamente.");
    } else {
      alert(`Se generaron guiones, pero hubo errores en las siguientes unidades:\n${errores.join(", ")}`);
    }
  };

  const handleDescargaGuion = async (unidadId, nombreUnidad) => {
    setCargando(true);
    try {
      const contenido = await obtenerGuion(unidadId, user.authorization.token);
      const blob = new Blob([contenido], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${nombreUnidad}.txt`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando guion:", error);
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      <Barra />
      <Box p={4} mt={10}>
        <Typography variant="h4" mb={3} sx={{ color: colores.titulo }}>
          Guiones por Asignatura
        </Typography>

        <Box mb={3} display="flex" gap={2} flexWrap="wrap">
          <TextField label="Filtrar por Asignatura" value={filtroModulo} onChange={(e) => setFiltroModulo(e.target.value)} />
          <TextField type="date" label="Desde" InputLabelProps={{ shrink: true }} value={filtroFechaInicio} onChange={(e) => setFiltroFechaInicio(e.target.value)} />
          <TextField type="date" label="Hasta" InputLabelProps={{ shrink: true }} value={filtroFechaFin} onChange={(e) => setFiltroFechaFin(e.target.value)} />
          <Button variant="outlined" onClick={limpiarFiltros} sx={{ color: colores.primario, borderColor: colores.primario }}>
            Limpiar Filtros
          </Button>
          <Button variant="contained" onClick={handleBuscar} sx={{ backgroundColor: colores.primario }}>
            Buscar
          </Button>
        </Box>

        {seleccionadas.length > 0 && (
          <Box mb={2}>
            <Button variant="contained" onClick={handleGenerarMasivo} sx={{ backgroundColor: colores.alerta }}>
              Generar Guiones Seleccionados ({seleccionadas.length})
            </Button>
          </Box>
        )}

        <TableContainer component={Paper}>
          <Box display="flex" justifyContent="space-between" alignItems="center" px={2}>
            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={(_, newPage) => setPage(newPage)}
              rowsPerPage={pageSize}
              onRowsPerPageChange={(e) => {
                setPageSize(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[10, 20, 50, 100]}
              labelRowsPerPage="Filas por página"
              labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`}
            />
            <Box display="flex" alignItems="center" gap={1}>
              <Typography>Página:</Typography>
              <TextField select value={page + 1} onChange={(e) => setPage(parseInt(e.target.value, 10) - 1)} size="small" sx={{ width: 100 }}>
                {Array.from({ length: totalPaginas }, (_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell onClick={() => handleOrdenar("codigo")} style={{ cursor: "pointer" }}>
                  <b>Código {ordenColumna === "codigo" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell onClick={() => handleOrdenar("name_descripcion")} style={{ cursor: "pointer" }}>
                  <b>Asignatura {ordenColumna === "name_descripcion" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell onClick={() => handleOrdenar("estudiantes")} style={{ cursor: "pointer" }}>
                  <b>N° Estudiantes {ordenColumna === "estudiantes" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell onClick={() => handleOrdenar("proximoInicio")} style={{ cursor: "pointer" }}>
                  <b>Próximo Inicio {ordenColumna === "proximoInicio" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell onClick={() => handleOrdenar("asignaturaano")} style={{ cursor: "pointer" }}>
                  <b>Año {ordenColumna === "asignaturaano" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell onClick={() => handleOrdenar("modalidad")} style={{ cursor: "pointer" }}>
                  <b>ONL/SEM {ordenColumna === "modalidad" ? (ordenAscendente ? "↑" : "↓") : ""}</b>
                </TableCell>
                <TableCell>
                  <b>Acciones</b>
                </TableCell>
                
              </TableRow>
            </TableHead>

            <TableBody>
              {modulosOrdenados.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{row.codigo}</TableCell>
                  <TableCell>{row.name_descripcion}</TableCell>
                  <TableCell>{row.estudiantes}</TableCell>
                  <TableCell>{row.proximoInicio ? new Date(row.proximoInicio).toLocaleDateString() : "Sin fecha"}</TableCell>
                  <TableCell>{row.asignaturaano}</TableCell>
                  <TableCell>{row.modalidad}</TableCell>
                  <TableCell>
                    {row.unidades.map((unidad) => {
                      const unidadKey = `${row.codigo}-${unidad.id}`;
                      const estaSeleccionada = seleccionadas.includes(unidadKey);
                      return (
                        <Box key={unidad.id} p={0} mt={0} sx={{ position: "relative" }}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Checkbox checked={estaSeleccionada} onChange={() => toggleSeleccion(row.codigo, unidad.id)} />
                            <Typography variant="body2" fontWeight="bold">
                              Unidad {unidad.unidad}: {unidad.name}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", gap: 1, ml: 4 }}>
                            <Button
                              size="small"
                              variant="outlined"
                              sx={{ color: colores.alerta, borderColor: colores.alerta }}
                              onClick={() => generarGuionUnidad(unidad.id, row.codigo)}
                            >
                              Generar Guion
                            </Button>
                            {unidad.guion && unidad.guion.length > 0 && (
                              <>
                                
                                <Button
                                  size="small"
                                  variant="contained"
                                  sx={{ backgroundColor: colores.primario }}
                                  onClick={() => navigate(`/guiones/${unidad.id}`)}
                                >
                                  Revisar Guion ({unidad.guion.length})
                                </Button>

                                <IconButton title="Descargar guion" onClick={() => handleDescargaGuion(unidad.id, `${row.codigo}_unidad_${unidad.unidad}`)}>
                                  <DownloadIcon />
                                </IconButton>

                              </>
                            )}

                            <Box key={unidad.id} p={0} mt={0} sx={{ position: "relative" }}>
                          <Box display="flex" alignItems="center" gap={1}>
                        
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{ color: colores.primario, borderColor: colores.primario }}
                                onClick={() => navigate(`/banco-imagenes/${unidad.id}`)}
                              >
                                Banco de Imágenes
                              </Button>
                              </Box>
                            </Box>

                          </Box>
                        </Box>
                        

                      );
                    })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {cargando && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={cargando}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Box>
    </>
  );
}
